import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  UncontrolledTooltip,
} from "reactstrap";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import Select from "react-select";

import schema from "./GroupValidation.js";
import { isArray } from "../../Libs/CustomMethods/customMethods";

import {
  getGroup,
  createGroup,
  editGroup,
  resetGroups,
} from "../../store/groups/actions";

import { setClassName } from "../../Libs/CrudUtils/crudUtils";

const NewGroup = ({ t }) => {
  let { idGroup } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const { successGroup, errorGroup, loadingGroup, dataGroup } = useSelector(
    (state) => state.Group
  );

  const [name, setName] = useState({});
  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [isLevel0, setIsLevel0] = useState(false);

  const [groupValues, setGroupValues] = useState({
    groups: {
      name: "",
      parent_id: "",
      manager: [],
      agent: [],
      add: [],
      remove: [],
    },
    groupsBk: {
      name: "",
      parent_id: "",
      manager: [],
      agent: [],
      level: 1,
    },
  });

  const newGroupSubmit = () => {
    handleCreateEditGroup();
  };

  const handleChange = (e) => {
    setGroupValues({
      ...groupValues,
      groups: { ...groupValues.groups, name: e ? e.target.value : "" },
    });
  };

  const handleCreateEditGroup = () => {
    let aux = newFields?.groups;
    if (!aux.manager) {
      aux.manager = [];
    } else {
      let prevManager = groupValues?.groupsBk?.manager;
      let nowManager = aux.manager;

      if (isArray(prevManager) && isArray(nowManager)) {
        let remove = prevManager.filter((x) => !nowManager.includes(x));
        let add = nowManager.filter((x) => !prevManager.includes(x));

        aux.remove = [...aux.remove, ...remove];
        aux.add = [...aux.add, ...add];
      }
    }
    if (!aux.agent) {
      aux.agent = [];
    } else {
      let prevAgent = groupValues?.groupsBk?.agent;
      let nowAgent = aux.agent;

      if (isArray(prevAgent) && isArray(nowAgent)) {
        let remove = prevAgent.filter((x) => !nowAgent.includes(x));
        let add = nowAgent.filter((x) => !prevAgent.includes(x));

        aux.remove = [...aux.remove, ...remove];
        aux.add = [...aux.add, ...add];
      }
    }

    aux.users = [...(aux?.agent ?? []), ...(aux?.manager ?? [])];
    delete newFields.groups.manager;
    delete newFields.groups.agent;
    delete newFields.groups.level;

    if (idGroup && newFields) {
      dispatch(editGroup(idGroup, newFields));
    } else if (!idGroup) {
      delete newFields.groups.add;
      delete newFields.groups.remove;
      dispatch(createGroup(newFields));
    }
  };

  const checkGroup = (values, valuesBk) => {
    if (JSON.stringify(values) === JSON.stringify(valuesBk)) {
      delete newFields.groups;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        groups: { ...values, remove: [], add: [] },
      });
    }
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  const optionsAgents = () => {
    let agents = [];

    if (dataGroup?.form?.agent?.length > 0) {
      dataGroup.form.agent.map((agent) =>
        agents.push({
          key: agent.id,
          value: agent.id,
          label: agent.name,
        })
      );
    } else {
      if (loadingGroup) {
        agents.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        agents.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return agents;
  };

  const optionsManagers = () => {
    let managers = [];
    if (dataGroup?.form?.manager?.length > 0) {
      dataGroup.form.manager.map((manager) =>
        managers.push({
          key: manager.id,
          value: manager.id,
          label: manager.name,
        })
      );
    } else {
      if (loadingGroup) {
        managers.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        managers.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return managers;
  };

  const optionsGroups = () => {
    let parent = [];
    if (dataGroup?.form?.parent_id?.length > 0) {
      dataGroup.form.parent_id.map((groupId) =>
        parent.push({
          key: groupId.id,
          value: groupId.id,
          label: groupId.name,
        })
      );
    } else {
      if (loadingGroup) {
        parent.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        parent.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return parent;
  };

  useEffect(() => {
    checkSubmit();
  }, [newFields, errors]);

  useEffect(() => {
    if (idGroup) {
      dispatch(getGroup(idGroup, true));
    } else {
      dispatch(getGroup(null, true));
    }
  }, [dispatch, idGroup]);

  useEffect(() => {
    if (idGroup && dataGroup?.data && !loadingGroup) {
      setGroupValues({
        groups: dataGroup.data,
        groupsBk: dataGroup.data,
      });
      setName(dataGroup.data.name);
      verifyLevel(dataGroup.data);
    }
  }, [dispatch, dataGroup, idGroup, loadingGroup]);

  const verifyLevel = (data) => {
    if (data?.level === 0) {
      setIsLevel0(true);
      setValue('isLevel0', true, { shouldValidate: true });
    }else{
      setValue('isLevel0', false, { shouldValidate: false });
    }
  };

  useEffect(() => {
    if (groupValues?.groups) {
      Object.entries(groupValues.groups).forEach((item) =>
        setValue(item[0], item[1], {
          shouldValidate: item[1],
        })
      );
    }

    checkGroup(groupValues.groups, groupValues.groupsBk);
  }, [groupValues, setValue]);

  let showToast = useCallback(function (type, msg) {
    toastr[type](msg);
  }, []);

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successGroup && history.push("/groups"),
  };

  useEffect(() => {
    if (successGroup && dataGroup) {
      showToast(
        "success",
        dataGroup?.newGroupValues?.groups?.add
          ? t("Group updated")
          : t("Group created")
      );
    }
  }, [successGroup, dataGroup, t, showToast]);

  useEffect(() => {
    if (isArray(errorGroup)) {
      errorGroup.forEach((e) => showToast("error", t(e.value)));
    } else if (errorGroup){
      showToast("error", t(errorGroup));
    }
    dispatch(resetGroups());
  }, [errorGroup, t, dispatch, showToast]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/groups"
            path={"/group"}
            title={t("Groups")}
            breadcrumbItem={idGroup ? t("Edit Group") : t("Create Group")}
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  {loadingGroup && !dataGroup ? (
                    <div className="text-center">
                      <Spinner size="sm" animation="border" />
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit(newGroupSubmit)}>
                      <Row className="mb-3">
                        <Col md="12" xl="9">
                          <FormGroup>
                            <Label>{t("Name") + " *"}</Label>
                            <input
                              ref={() => register({ name: "name" })}
                              type="text"
                              className={setClassName(
                                errors?.name,
                                "form-control"
                              )}
                              placeholder={t("Enter group name")}
                              onChange={handleChange}
                              value={groupValues?.groups?.name ?? ""}
                            />
                            <div className="invalid-feedback d-block">
                              {t(errors?.name?.message)}
                            </div>
                          </FormGroup>
                          <FormGroup className="select2-container">
                            <div className="d-flex justify-content-between w-100">
                              <div>
                                <Label className="control-label">
                                  {t("Agent")}
                                </Label>
                                <i
                                  className="fas fa-info-circle px-2 pointer"
                                  id="agent-tooltip"
                                />
                                <UncontrolledTooltip
                                  placement="auto"
                                  target="agent-tooltip"
                                >
                                  {t("Add agents to the group")}
                                </UncontrolledTooltip>
                              </div>
                            </div>
                            <Select
                              ref={() => register({ name: "agent_id" })}
                              classNamePrefix="select2-selection"
                              placeholder={t("Select") + "..."}
                              options={optionsAgents()}
                              onChange={(e) => {
                                setGroupValues({
                                  ...groupValues,
                                  groups: {
                                    ...groupValues.groups,
                                    agent: e ? e.map((item) => item.value) : [],
                                    add: [],
                                    remove: [],
                                  },
                                });
                              }}
                              value={optionsAgents().filter((element) =>
                                groupValues?.groups?.agent?.includes(
                                  element.value
                                )
                              )}
                              isMulti
                            />
                            <div className="invalid-feedback d-block">
                              {t(errors?.agent?.message)}
                            </div>
                          </FormGroup>
                          <FormGroup className="select2-container">
                            <div className="d-flex justify-content-between w-100">
                              <div>
                                <Label className="control-label">
                                  {t("Manager")}
                                </Label>
                                <i
                                  className="fas fa-info-circle px-2 pointer"
                                  id="manager-tooltip"
                                />
                                <UncontrolledTooltip
                                  placement="auto"
                                  target="manager-tooltip"
                                >
                                  {t("Add managers to the group")}
                                </UncontrolledTooltip>
                              </div>
                            </div>
                            <Select
                              ref={() => register({ name: "manager_id" })}
                              classNamePrefix="select2-selection"
                              className={setClassName(
                                errors?.manager,
                                "select2-selection"
                              )}
                              placeholder={t("Select") + "..."}
                              options={optionsManagers()}
                              onChange={(e) => {
                                setGroupValues({
                                  ...groupValues,
                                  groups: {
                                    ...groupValues.groups,
                                    manager: e
                                      ? e.map((item) => item.value)
                                      : [],
                                    add: [],
                                    remove: [],
                                  },
                                });
                              }}
                              value={optionsManagers().filter((element) =>
                                groupValues?.groups?.manager?.includes(
                                  element.value
                                )
                              )}
                              isMulti
                            />
                            <div className="invalid-feedback d-block">
                              {t(errors?.manager?.message)}
                            </div>
                          </FormGroup>
                          {isLevel0 === false ? (
                            <FormGroup className="select2-container">
                              <div className="d-flex justify-content-between w-100">
                                <div>
                                  <Label className="control-label">
                                    {t("Parent Group")}
                                  </Label>
                                  <i
                                    className="fas fa-info-circle px-2 pointer"
                                    id="parent-id-tooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="auto"
                                    target="parent-id-tooltip"
                                  >
                                    {t("Add parent group to the group")}
                                  </UncontrolledTooltip>
                                </div>
                              </div>
                              <Select
                                ref={() => register({ name: "parent_id" })}
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors?.parent_id,
                                  "select2-selection"
                                )}
                                placeholder={t("Select") + "..."}
                                options={optionsGroups()}
                                onChange={(e) => {
                                  setGroupValues({
                                    ...groupValues,
                                    groups: {
                                      ...groupValues.groups,
                                      parent_id: e?.value ? e.value : "",
                                    },
                                  });
                                }}
                                value={optionsGroups().filter(
                                  (element) =>
                                    element.value ===
                                    groupValues?.groups?.parent_id
                                )}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors?.parent_id?.message)}
                              </div>
                            </FormGroup>
                          ) : (
                            false
                          )}
                        </Col>
                      </Row>
                      <Button
                        style={{
                          minWidth: "100px",
                          cursor: enableSubmit ? "pointer" : "no-drop",
                        }}
                        disabled={!enableSubmit}
                        type="submit"
                        color="primary"
                        className="mr-1 waves-effect waves-light"
                      >
                        {loadingGroup ? (
                          <Spinner
                            size="sm"
                            animation="border"
                            style={{
                              height: "19px",
                              width: "19px",
                            }}
                          />
                        ) : (
                          t("Confirm")
                        )}
                      </Button>
                      <Link to="/groups">
                        {" "}
                        <Button
                          type="button"
                          color="secondary"
                          className="waves-effect btn-dark"
                        >
                          {t("Cancel")}
                        </Button>
                      </Link>
                    </form>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewGroup);
